import { uniq } from "lodash";

export function getPayerAccountIDs(recs: { cloudID: string }[]) {
  return uniq(recs.map((rec) => rec.cloudID)).sort();
}
